// GENERERT — ikke rediger for hånd.
// Kilde: vale/data/kritiske-objekter-j5.md (J-5). Generator: scripts/gen-kritiske-objekter.mjs
// 218 objekter totalt (218 gyldige tegnes + 0 suspekte skjules) · 12 distrikter · MIL 93 / EN 51 / TR 75
// Kartlag «Kritiske objekter» i COP: APP-6 installasjonssymboler, toggle av/på, undergrupper MIL/EN/TR (default AV).
import { z } from 'zod';
/** Kategori for et kritisk objekt. MIL=militær/forsvar, EN=energi, TR=transport/logistikk. */
export const KritiskKategoriSchema = z.enum(['MIL', 'EN', 'TR']);
export const KritiskObjektSchema = z.object({
    id: z.string(),
    name: z.string(),
    district: z.string(),
    districtName: z.string(),
    mgrs: z.string(),
    lat: z.number(),
    lon: z.number(),
    kat: KritiskKategoriSchema,
    cats: z.array(KritiskKategoriSchema).min(1),
    why: z.string(),
    // true = koordinat falt utenfor Norge-boksen (feil i MGRS-kilden). COP kan
    // skjule/markere disse; retter i vale/data/kritiske-objekter-j5.md.
    suspect: z.boolean(),
});
/** Alle kritiske objekter (J-5), sortert som i kildelista. */
export const KRITISKE_OBJEKTER = [
    {
        "id": "KO-HV-01-001",
        "name": "Rygge Flystasjon (SK HV-01)",
        "district": "HV-01",
        "districtName": "HV-01 Oslofjord (Østfold/Vestfold)",
        "mgrs": "32V PL 0123 9876",
        "lat": 59.51503,
        "lon": 10.789,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "339 skv/134 LV, alliert luftmottak, HV-01 KO",
        "suspect": false
    },
    {
        "id": "KO-HV-01-002",
        "name": "Karljohansvern og Vealøs (Horten)",
        "district": "HV-01",
        "districtName": "HV-01 Oslofjord (Østfold/Vestfold)",
        "mgrs": "32V NL 9012 3456",
        "lat": 58.94125,
        "lon": 10.56612,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "FFI maritim FoU (HUGIN AUV), dypvannskai",
        "suspect": false
    },
    {
        "id": "KO-HV-01-003",
        "name": "Rauøy (FS øvingsanlegg)",
        "district": "HV-01",
        "districtName": "HV-01 Oslofjord (Østfold/Vestfold)",
        "mgrs": "32V PL 0200 7500",
        "lat": 59.30158,
        "lon": 10.7913,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "FSK/MJK, chokepoint innseiling Oslo",
        "suspect": false
    },
    {
        "id": "KO-HV-01-004",
        "name": "Mågerø Radarstasjon (Tjøme)",
        "district": "HV-01",
        "districtName": "HV-01 Oslofjord (Østfold/Vestfold)",
        "mgrs": "32V NL 8500 2000",
        "lat": 58.81157,
        "lon": 10.47162,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "radarhode Oslofjord/Skagerrak",
        "suspect": false
    },
    {
        "id": "KO-HV-01-005",
        "name": "Kystvaktbase Sør (Horten)",
        "district": "HV-01",
        "districtName": "HV-01 Oslofjord (Østfold/Vestfold)",
        "mgrs": "32V NL 8950 3500",
        "lat": 58.94533,
        "lon": 10.55553,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "Indre Kystvakt HK Sør-Norge",
        "suspect": false
    },
    {
        "id": "KO-HV-01-006",
        "name": "Gjølsjø Skyte-/øvingsfelt (Marker)",
        "district": "HV-01",
        "districtName": "HV-01 Oslofjord (Østfold/Vestfold)",
        "mgrs": "32V PL 3000 9500",
        "lat": 59.47335,
        "lon": 11.2947,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "største ØF-felt, Polar Bear VI",
        "suspect": false
    },
    {
        "id": "KO-HV-01-007",
        "name": "Torp Flystasjon (mil.del/APOD)",
        "district": "HV-01",
        "districtName": "HV-01 Oslofjord (Østfold/Vestfold)",
        "mgrs": "32V NL 3456 7890",
        "lat": 59.3475,
        "lon": 9.60777,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "alliert luftmottak",
        "suspect": false
    },
    {
        "id": "KO-HV-01-008",
        "name": "FLO Base Rygge",
        "district": "HV-01",
        "districtName": "HV-01 Oslofjord (Østfold/Vestfold)",
        "mgrs": "32V PL 0150 9900",
        "lat": 59.51712,
        "lon": 10.79388,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "forsyningsdepot Østlandet",
        "suspect": false
    },
    {
        "id": "KO-HV-01-009",
        "name": "Slagentangen Oljeterminal (NATO POL)",
        "district": "HV-01",
        "districtName": "HV-01 Oslofjord (Østfold/Vestfold)",
        "mgrs": "32V PL 0987 5432",
        "lat": 59.114,
        "lon": 10.91897,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "F-34/Jet A-1 til Østlandet",
        "suspect": false
    },
    {
        "id": "KO-HV-01-010",
        "name": "Borg Havn (SPOD Østfold)",
        "district": "HV-01",
        "districtName": "HV-01 Oslofjord (Østfold/Vestfold)",
        "mgrs": "32V PL 1234 6789",
        "lat": 59.23514,
        "lon": 10.96907,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "alliert RoRo-mottak",
        "suspect": false
    },
    {
        "id": "KO-HV-01-011",
        "name": "Larvik Havn (SPOD Vestfold)",
        "district": "HV-01",
        "districtName": "HV-01 Oslofjord (Østfold/Vestfold)",
        "mgrs": "32V NL 5678 1234",
        "lat": 58.74743,
        "lon": 9.98123,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "dypvannshavn mot E18",
        "suspect": false
    },
    {
        "id": "KO-HV-01-012",
        "name": "Tjøme Kystradio (mar. samband)",
        "district": "HV-01",
        "districtName": "HV-01 Oslofjord (Østfold/Vestfold)",
        "mgrs": "32V NL 8300 1500",
        "lat": 58.76707,
        "lon": 10.43515,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "kryptert maritim komm.",
        "suspect": false
    },
    {
        "id": "KO-HV-01-013",
        "name": "Svinesundbruene/toll (E6)",
        "district": "HV-01",
        "districtName": "HV-01 Oslofjord (Østfold/Vestfold)",
        "mgrs": "32V PL 3450 2100",
        "lat": 58.80794,
        "lon": 11.3285,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "hovedakse import + NATO-logistikk",
        "suspect": false
    },
    {
        "id": "KO-HV-01-014",
        "name": "Slagentangen Essoraffineri",
        "district": "HV-01",
        "districtName": "HV-01 Oslofjord (Østfold/Vestfold)",
        "mgrs": "32V NL 8650 7150",
        "lat": 59.27362,
        "lon": 10.51783,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "drivstoffproduksjon/lagring",
        "suspect": false
    },
    {
        "id": "KO-HV-01-015",
        "name": "Vamma Kraftverk (Glomma)",
        "district": "HV-01",
        "districtName": "HV-01 Oslofjord (Østfold/Vestfold)",
        "mgrs": "32V PL 2850 6750",
        "lat": 59.22705,
        "lon": 11.25184,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "Norges største elvekraftverk",
        "suspect": false
    },
    {
        "id": "KO-HV-01-016",
        "name": "Oslofjordtunnelen (E134)",
        "district": "HV-01",
        "districtName": "HV-01 Oslofjord (Østfold/Vestfold)",
        "mgrs": "32V PL 0550 8250",
        "lat": 59.36804,
        "lon": 10.8564,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "omkjøringsakse øst-vest",
        "suspect": false
    },
    {
        "id": "KO-HV-01-017",
        "name": "Ferge Moss–Horten (Bastø)",
        "district": "HV-01",
        "districtName": "HV-01 Oslofjord (Østfold/Vestfold)",
        "mgrs": "32V NL 9550 5650",
        "lat": 59.13703,
        "lon": 10.66908,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "flytende E6/E18",
        "suspect": false
    },
    {
        "id": "KO-HV-01-018",
        "name": "Hasle Trafostasjon (Sarpsborg)",
        "district": "HV-01",
        "districtName": "HV-01 Oslofjord (Østfold/Vestfold)",
        "mgrs": "32V PL 2550 3450",
        "lat": 58.93181,
        "lon": 11.18044,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "420kV NO-SE-utveksling",
        "suspect": false
    },
    {
        "id": "KO-HV-01-019",
        "name": "Ørje Tollsted/grense (E18)",
        "district": "HV-01",
        "districtName": "HV-01 Oslofjord (Østfold/Vestfold)",
        "mgrs": "32V PL 4550 5650",
        "lat": 59.12287,
        "lon": 11.54208,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "østre forsyningsvei",
        "suspect": false
    },
    {
        "id": "KO-HV-01-020",
        "name": "Rolvsøysund bru (bane/vei)",
        "district": "HV-01",
        "districtName": "HV-01 Oslofjord (Østfold/Vestfold)",
        "mgrs": "32V PL 1550 3150",
        "lat": 58.90769,
        "lon": 11.00528,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "Østfoldbanen over Glomma",
        "suspect": false
    },
    {
        "id": "KO-HV-02-021",
        "name": "Akershus Festning (FD/FST)",
        "district": "HV-02",
        "districtName": "HV-02 Oslo og Akershus",
        "mgrs": "32V PM 0110 4220",
        "lat": 59.90494,
        "lon": 10.80761,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "nasjonal strategisk C2",
        "suspect": false
    },
    {
        "id": "KO-HV-02-022",
        "name": "Lutvann Leir (SK HV-02 / E-tj / CYFOR)",
        "district": "HV-02",
        "districtName": "HV-02 Oslo og Akershus",
        "mgrs": "32V PM 0450 4500",
        "lat": 59.92922,
        "lon": 10.86977,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "E-tjeneste + cyber HK",
        "suspect": false
    },
    {
        "id": "KO-HV-02-023",
        "name": "Kolsås Leir (NATO sambandsnode)",
        "district": "HV-02",
        "districtName": "HV-02 Oslo og Akershus",
        "mgrs": "32V NM 8600 4550",
        "lat": 59.93799,
        "lon": 10.53914,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "C4ISR fjellanlegg, NSM",
        "suspect": false
    },
    {
        "id": "KO-HV-02-024",
        "name": "Gardermoen Flystasjon (135 LV/APOD)",
        "district": "HV-02",
        "districtName": "HV-02 Oslo og Akershus",
        "mgrs": "32V PM 1250 7600",
        "lat": 60.2053,
        "lon": 11.02983,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "C-130J, hoved-APOD",
        "suspect": false
    },
    {
        "id": "KO-HV-02-025",
        "name": "Sessvollmoen Leir (FLO/FSAN)",
        "district": "HV-02",
        "districtName": "HV-02 Oslo og Akershus",
        "mgrs": "32V PM 1100 8100",
        "lat": 60.25058,
        "lon": 11.00552,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "logistikk-tyngdepunkt",
        "suspect": false
    },
    {
        "id": "KO-HV-02-026",
        "name": "Huseby Leir (HMKG)",
        "district": "HV-02",
        "districtName": "HV-02 Oslo og Akershus",
        "mgrs": "32V NM 9400 4500",
        "lat": 59.93175,
        "lon": 10.68201,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "hovedstadsforsvar",
        "suspect": false
    },
    {
        "id": "KO-HV-02-027",
        "name": "Hauerseter Leir (FLO ammo)",
        "district": "HV-02",
        "districtName": "HV-02 Oslo og Akershus",
        "mgrs": "32V PM 1600 8300",
        "lat": 60.26713,
        "lon": 11.09694,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "ammunisjonsdepot",
        "suspect": false
    },
    {
        "id": "KO-HV-02-028",
        "name": "FFI/Base Kjeller",
        "district": "HV-02",
        "districtName": "HV-02 Oslo og Akershus",
        "mgrs": "32V PM 1200 5000",
        "lat": 59.97212,
        "lon": 11.00658,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "missil/cyber/EK-forskning",
        "suspect": false
    },
    {
        "id": "KO-HV-02-029",
        "name": "Oslo Havn (SPOD)",
        "district": "HV-02",
        "districtName": "HV-02 Oslo og Akershus",
        "mgrs": "32V PM 0120 4150",
        "lat": 59.89864,
        "lon": 10.80905,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "RoRo alliert panser",
        "suspect": false
    },
    {
        "id": "KO-HV-02-030",
        "name": "Linderud Leir (Krigsskolen)",
        "district": "HV-02",
        "districtName": "HV-02 Oslo og Akershus",
        "mgrs": "32V PM 0250 4700",
        "lat": 59.94768,
        "lon": 10.835,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "utdanning, alt. KO",
        "suspect": false
    },
    {
        "id": "KO-HV-02-031",
        "name": "Sjursøya Oljeterminal",
        "district": "HV-02",
        "districtName": "HV-02 Oslo og Akershus",
        "mgrs": "32V PM 0120 4150",
        "lat": 59.89864,
        "lon": 10.80905,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "flydrivstoff OSL + bakkestyrker",
        "suspect": false
    },
    {
        "id": "KO-HV-02-032",
        "name": "Alnabru Godsterminal",
        "district": "HV-02",
        "districtName": "HV-02 Oslo og Akershus",
        "mgrs": "32V PM 0450 4550",
        "lat": 59.93371,
        "lon": 10.87002,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "største jernbane-omlasting",
        "suspect": false
    },
    {
        "id": "KO-HV-02-033",
        "name": "Minnesundbruene (E6/Dovrebanen)",
        "district": "HV-02",
        "districtName": "HV-02 Oslo og Akershus",
        "mgrs": "32V PM 4560 1230",
        "lat": 59.62343,
        "lon": 11.5816,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "chokepoint E6+bane",
        "suspect": false
    },
    {
        "id": "KO-HV-02-034",
        "name": "Oslotunnelen (jernbane)",
        "district": "HV-02",
        "districtName": "HV-02 Oslo og Akershus",
        "mgrs": "32V PM 0010 4320",
        "lat": 59.91416,
        "lon": 10.79022,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "all vestgående togtrafikk",
        "suspect": false
    },
    {
        "id": "KO-HV-02-035",
        "name": "Frogner Trafostasjon",
        "district": "HV-02",
        "districtName": "HV-02 Oslo og Akershus",
        "mgrs": "32V PM 3450 1230",
        "lat": 59.62715,
        "lon": 11.385,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "420kV Romerike/OSL",
        "suspect": false
    },
    {
        "id": "KO-HV-02-036",
        "name": "Sogn Trafostasjon (Oslo)",
        "district": "HV-02",
        "districtName": "HV-02 Oslo og Akershus",
        "mgrs": "32V NM 9550 4850",
        "lat": 59.96282,
        "lon": 10.71045,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "kraft til regjeringskvartal/sykehus",
        "suspect": false
    },
    {
        "id": "KO-HV-02-037",
        "name": "NIX (Oslo)",
        "district": "HV-02",
        "districtName": "HV-02 Oslo og Akershus",
        "mgrs": "32V PM 0150 4320",
        "lat": 59.91382,
        "lon": 10.81525,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "nasjonal internett-ruting",
        "suspect": false
    },
    {
        "id": "KO-HV-02-038",
        "name": "Gardermoen POL/drivstoff",
        "district": "HV-02",
        "districtName": "HV-02 Oslo og Akershus",
        "mgrs": "32V PM 1250 7600",
        "lat": 60.2053,
        "lon": 11.02983,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "jetfuel APOD",
        "suspect": false
    },
    {
        "id": "KO-HV-02-039",
        "name": "Nittedal Jordstasjon (SATCOM)",
        "district": "HV-02",
        "districtName": "HV-02 Oslo og Akershus",
        "mgrs": "32V PM 0560 6780",
        "lat": 60.13356,
        "lon": 10.90116,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "satellittkomm C4ISR",
        "suspect": false
    },
    {
        "id": "KO-HV-02-040",
        "name": "Oslo Havn Sydhavna/Vippetangen",
        "district": "HV-02",
        "districtName": "HV-02 Oslo og Akershus",
        "mgrs": "32V PM 0120 4150",
        "lat": 59.89864,
        "lon": 10.80905,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "SPOD konteiner/RoRo",
        "suspect": false
    },
    {
        "id": "KO-HV-03-041",
        "name": "Heistadmoen Leir (SK HV-03)",
        "district": "HV-03",
        "districtName": "HV-03 Telemark og Buskerud",
        "mgrs": "32V NM 3150 0950",
        "lat": 59.62251,
        "lon": 9.55849,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "KO + Gunnerside",
        "suspect": false
    },
    {
        "id": "KO-HV-03-042",
        "name": "Kongsberg Defence & Aerospace",
        "district": "HV-03",
        "districtName": "HV-03 Telemark og Buskerud",
        "mgrs": "32V NM 3250 1020",
        "lat": 59.62872,
        "lon": 9.57632,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "NASAMS/NSM/JSM-produksjon",
        "suspect": false
    },
    {
        "id": "KO-HV-03-043",
        "name": "Gaustatoppen NATO sambandsnode",
        "district": "HV-03",
        "districtName": "HV-03 Telemark og Buskerud",
        "mgrs": "32V MM 8550 3550",
        "lat": 59.85692,
        "lon": 8.74125,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "fjellanlegg kryptert komm.",
        "suspect": false
    },
    {
        "id": "KO-HV-03-044",
        "name": "Drammen Havn (SPOD/Holmen)",
        "district": "HV-03",
        "districtName": "HV-03 Telemark og Buskerud",
        "mgrs": "32V NM 6510 2420",
        "lat": 59.7506,
        "lon": 10.15855,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "største RoRo-kjøretøyimport",
        "suspect": false
    },
    {
        "id": "KO-HV-03-045",
        "name": "Hengsvann Skyte-/øvingsfelt",
        "district": "HV-03",
        "districtName": "HV-03 Telemark og Buskerud",
        "mgrs": "32V NM 2800 1500",
        "lat": 59.67215,
        "lon": 9.49717,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "FSK/Hær/HV",
        "suspect": false
    },
    {
        "id": "KO-HV-03-046",
        "name": "Eggemoen Teknologipark/flyplass",
        "district": "HV-03",
        "districtName": "HV-03 Telemark og Buskerud",
        "mgrs": "32V NM 7700 7500",
        "lat": 60.20458,
        "lon": 10.38922,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "UAS-testing, mulig FARP",
        "suspect": false
    },
    {
        "id": "KO-HV-03-047",
        "name": "FLO fjellanlegg (Buskerud/Telemark)",
        "district": "HV-03",
        "districtName": "HV-03 Telemark og Buskerud",
        "mgrs": "32V NM 1500 0200",
        "lat": 59.55608,
        "lon": 9.26547,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "skjermet depot",
        "suspect": false
    },
    {
        "id": "KO-HV-03-048",
        "name": "Numedalsaksen (Kongsberg-Geilo)",
        "district": "HV-03",
        "districtName": "HV-03 Telemark og Buskerud",
        "mgrs": "32V NM 3000 3500",
        "lat": 59.85159,
        "lon": 9.53555,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "indre forsyningslinje",
        "suspect": false
    },
    {
        "id": "KO-HV-03-049",
        "name": "Sylling Trafostasjon (Lier)",
        "district": "HV-03",
        "districtName": "HV-03 Telemark og Buskerud",
        "mgrs": "32V NM 6350 3550",
        "lat": 59.85229,
        "lon": 10.13353,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "420kV øst-vest",
        "suspect": false
    },
    {
        "id": "KO-HV-03-050",
        "name": "Herøya Industripark (Porsgrunn)",
        "district": "HV-03",
        "districtName": "HV-03 Telemark og Buskerud",
        "mgrs": "32V NL 3350 5650",
        "lat": 59.14644,
        "lon": 9.58567,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "kjemisk/gjødsel (Yara)",
        "suspect": false
    },
    {
        "id": "KO-HV-03-051",
        "name": "Tokke Kraftverk (Dalen)",
        "district": "HV-03",
        "districtName": "HV-03 Telemark og Buskerud",
        "mgrs": "32V ML 5670 9010",
        "lat": 59.44726,
        "lon": 8.23648,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "regulerkraft + utenlandskabler",
        "suspect": false
    },
    {
        "id": "KO-HV-03-052",
        "name": "Breviksbrua/Grenlandsbrua (E18)",
        "district": "HV-03",
        "districtName": "HV-03 Telemark og Buskerud",
        "mgrs": "32V NL 3750 4850",
        "lat": 59.07426,
        "lon": 9.65422,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "Sørlandskorridor chokepoint",
        "suspect": false
    },
    {
        "id": "KO-HV-03-053",
        "name": "Breviksterminalen/Norcem",
        "district": "HV-03",
        "districtName": "HV-03 Telemark og Buskerud",
        "mgrs": "32V NL 3850 4750",
        "lat": 59.06519,
        "lon": 9.67149,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "sement (strategisk) + SPOD-reserve",
        "suspect": false
    },
    {
        "id": "KO-HV-03-054",
        "name": "Hønefoss stasjon/Roa-linjen",
        "district": "HV-03",
        "districtName": "HV-03 Telemark og Buskerud",
        "mgrs": "32V NM 7050 6750",
        "lat": 60.13843,
        "lon": 10.26939,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "Bergensbane-kryss",
        "suspect": false
    },
    {
        "id": "KO-HV-03-055",
        "name": "Nore Kraftverk I/II",
        "district": "HV-03",
        "districtName": "HV-03 Telemark og Buskerud",
        "mgrs": "32V MM 8550 7850",
        "lat": 60.24302,
        "lon": 8.73821,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "grunnlast Numedal, demning",
        "suspect": false
    },
    {
        "id": "KO-HV-03-056",
        "name": "E134 Haukelitunnelen",
        "district": "HV-03",
        "districtName": "HV-03 Telemark og Buskerud",
        "mgrs": "32V MM 3450 3250",
        "lat": 59.82505,
        "lon": 7.83191,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "vintersikker øst-vest",
        "suspect": false
    },
    {
        "id": "KO-HV-03-057",
        "name": "Vemork/Rjukan Kraftverk",
        "district": "HV-03",
        "districtName": "HV-03 Telemark og Buskerud",
        "mgrs": "32V MM 7750 3950",
        "lat": 59.89248,
        "lon": 8.598,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "grunnlast + støtter Gaustad",
        "suspect": false
    },
    {
        "id": "KO-HV-05-058",
        "name": "Terningmoen Leir (SK HV-05 / HVS)",
        "district": "HV-05",
        "districtName": "HV-05 Opplandske (Innlandet)",
        "mgrs": "32V PN 7654 4321",
        "lat": 60.78511,
        "lon": 12.24319,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "KO + Hærens våpenskole",
        "suspect": false
    },
    {
        "id": "KO-HV-05-059",
        "name": "Rena Leir (HRF/FSK)",
        "district": "HV-05",
        "districtName": "HV-05 Opplandske (Innlandet)",
        "mgrs": "32V PN 9876 8765",
        "lat": 61.1728,
        "lon": 12.69645,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "TMBN + FSK",
        "suspect": false
    },
    {
        "id": "KO-HV-05-060",
        "name": "Raufoss (Nammo AS)",
        "district": "HV-05",
        "districtName": "HV-05 Opplandske (Innlandet)",
        "mgrs": "32V NN 9012 3456",
        "lat": 60.73644,
        "lon": 10.65278,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "ammo/rakettmotor HVT",
        "suspect": false
    },
    {
        "id": "KO-HV-05-061",
        "name": "Jørstadmoen Leir (Cyberforsvaret)",
        "district": "HV-05",
        "districtName": "HV-05 Opplandske (Innlandet)",
        "mgrs": "32V NN 7890 8765",
        "lat": 61.2153,
        "lon": 10.46892,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "CYFOR HK",
        "suspect": false
    },
    {
        "id": "KO-HV-05-062",
        "name": "Regionfelt Østlandet (RØ)",
        "district": "HV-05",
        "districtName": "HV-05 Opplandske (Innlandet)",
        "mgrs": "32V PN 9500 9500",
        "lat": 61.24054,
        "lon": 12.63429,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "største skytefelt",
        "suspect": false
    },
    {
        "id": "KO-HV-05-063",
        "name": "Dombås Fjellanlegg/FLO ammo",
        "district": "HV-05",
        "districtName": "HV-05 Opplandske (Innlandet)",
        "mgrs": "32V NQ 1234 5678",
        "lat": 62.74126,
        "lon": 9.24158,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "depot bane-kryss",
        "suspect": false
    },
    {
        "id": "KO-HV-05-064",
        "name": "Haslemoen flystripe (Solør)",
        "district": "HV-05",
        "districtName": "HV-05 Opplandske (Innlandet)",
        "mgrs": "32V PN 8500 2500",
        "lat": 60.61806,
        "lon": 12.38109,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "FARP C-130",
        "suspect": false
    },
    {
        "id": "KO-HV-05-065",
        "name": "Dovrebanen/Østerdalsbanen",
        "district": "HV-05",
        "districtName": "HV-05 Opplandske (Innlandet)",
        "mgrs": "32V NQ 2200 4400",
        "lat": 62.6261,
        "lon": 9.42896,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "primær nord-sør bane",
        "suspect": false
    },
    {
        "id": "KO-HV-05-066",
        "name": "Dombås jernbaneknutepunkt",
        "district": "HV-05",
        "districtName": "HV-05 Opplandske (Innlandet)",
        "mgrs": "32V NQ 1250 6350",
        "lat": 62.80157,
        "lon": 9.24522,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "Raumabane×Dovrebane",
        "suspect": false
    },
    {
        "id": "KO-HV-05-067",
        "name": "Mjøsbrua (E6/Moelv)",
        "district": "HV-05",
        "districtName": "HV-05 Opplandske (Innlandet)",
        "mgrs": "32V PN 0150 4850",
        "lat": 60.85879,
        "lon": 10.86862,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "E6 over Mjøsa",
        "suspect": false
    },
    {
        "id": "KO-HV-05-068",
        "name": "Rv3 broer over Glomma (Elverum/Rena)",
        "district": "HV-05",
        "districtName": "HV-05 Opplandske (Innlandet)",
        "mgrs": "32V PN 7450 4250",
        "lat": 60.77964,
        "lon": 12.20515,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "mil. grønn akse",
        "suspect": false
    },
    {
        "id": "KO-HV-05-069",
        "name": "Nedre Vinstra Kraftverk",
        "district": "HV-05",
        "districtName": "HV-05 Opplandske (Innlandet)",
        "mgrs": "32V NP 4150 2550",
        "lat": 61.56082,
        "lon": 9.78122,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "grunnlast Gudbrandsdal",
        "suspect": false
    },
    {
        "id": "KO-HV-05-070",
        "name": "Kongsvinger stasjon/grensespor",
        "district": "HV-05",
        "districtName": "HV-05 Opplandske (Innlandet)",
        "mgrs": "32V PM 3550 7850",
        "lat": 60.22073,
        "lon": 11.44606,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "bane mot Sverige",
        "suspect": false
    },
    {
        "id": "KO-HV-05-071",
        "name": "Fåberg Trafostasjon (Lillehammer)",
        "district": "HV-05",
        "districtName": "HV-05 Opplandske (Innlandet)",
        "mgrs": "32V NN 7650 7550",
        "lat": 61.10673,
        "lon": 10.41935,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "kraft Gudbrandsdal/CYFOR",
        "suspect": false
    },
    {
        "id": "KO-HV-05-072",
        "name": "E16 Filefjell/Tyin",
        "district": "HV-05",
        "districtName": "HV-05 Opplandske (Innlandet)",
        "mgrs": "32V MN 4850 7850",
        "lat": 61.13773,
        "lon": 8.04374,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "vintersikker øst-vest",
        "suspect": false
    },
    {
        "id": "KO-HV-05-073",
        "name": "E6 Dovrefjell/Drivdalen",
        "district": "HV-05",
        "districtName": "HV-05 Opplandske (Innlandet)",
        "mgrs": "32V NQ 2550 9150",
        "lat": 63.0522,
        "lon": 9.50443,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "flaskehals nord",
        "suspect": false
    },
    {
        "id": "KO-HV-05-074",
        "name": "Solørbanen (Elverum-Kongsvinger)",
        "district": "HV-05",
        "districtName": "HV-05 Opplandske (Innlandet)",
        "mgrs": "32V PN 8550 1550",
        "lat": 60.53268,
        "lon": 12.38129,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "skjult godsbane",
        "suspect": false
    },
    {
        "id": "KO-HV-05-075",
        "name": "Lærdal-Aurdal kraftnett (Valdres)",
        "district": "HV-05",
        "districtName": "HV-05 Opplandske (Innlandet)",
        "mgrs": "32V MN 5550 6650",
        "lat": 61.03087,
        "lon": 8.17651,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "øst-vest kraftlinje",
        "suspect": false
    },
    {
        "id": "KO-HV-07-076",
        "name": "Kjevik Flystasjon (SK HV-07/APOD)",
        "district": "HV-07",
        "districtName": "HV-07 Agder",
        "mgrs": "32V MK 4450 2050",
        "lat": 57.92285,
        "lon": 8.06314,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "KO + Varg, luftmottak",
        "suspect": false
    },
    {
        "id": "KO-HV-07-077",
        "name": "Umoe Mandal (verft)",
        "district": "HV-07",
        "districtName": "HV-07 Agder",
        "mgrs": "32V MK 0950 0120",
        "lat": 57.74382,
        "lon": 7.47978,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "Skjold-klasse komposittfartøy",
        "suspect": false
    },
    {
        "id": "KO-HV-07-078",
        "name": "Evjemoen Skyte-/øvingsfelt",
        "district": "HV-07",
        "districtName": "HV-07 Agder",
        "mgrs": "32V MK 3600 6500",
        "lat": 58.32133,
        "lon": 7.90751,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "regionens øvingsfelt",
        "suspect": false
    },
    {
        "id": "KO-HV-07-079",
        "name": "Kristiansand Havn (SPOD Sør)",
        "district": "HV-07",
        "districtName": "HV-07 Agder",
        "mgrs": "32V MK 3950 1350",
        "lat": 57.85933,
        "lon": 7.98053,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "RoRo NATO + ferge DK",
        "suspect": false
    },
    {
        "id": "KO-HV-07-080",
        "name": "Lista Flypark/øvingsområde",
        "district": "HV-07",
        "districtName": "HV-07 Agder",
        "mgrs": "32V LK 6600 0950",
        "lat": 57.80745,
        "lon": 6.74493,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "FARP, kyst mot Nordsjøen",
        "suspect": false
    },
    {
        "id": "KO-HV-07-081",
        "name": "Kystradarkjede Sør (Lindesnes)",
        "district": "HV-07",
        "districtName": "HV-07 Agder",
        "mgrs": "32V LK 8500 0200",
        "lat": 57.7454,
        "lon": 7.06807,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "maritimt situasjonsbilde",
        "suspect": false
    },
    {
        "id": "KO-HV-07-082",
        "name": "FLO fjellanlegg/POL (Agder)",
        "district": "HV-07",
        "districtName": "HV-07 Agder",
        "mgrs": "32V MK 4000 1800",
        "lat": 57.89981,
        "lon": 7.98782,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "skjult drivstoffdepot",
        "suspect": false
    },
    {
        "id": "KO-HV-07-083",
        "name": "Tonstad Kraftverk (Sirdal)",
        "district": "HV-07",
        "districtName": "HV-07 Agder",
        "mgrs": "32V LK 6550 0950",
        "lat": 57.8073,
        "lon": 6.73653,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "største årsproduksjon, utenlandskabler",
        "suspect": false
    },
    {
        "id": "KO-HV-07-084",
        "name": "Feda Omformerstasjon (Kvinesdal)",
        "district": "HV-07",
        "districtName": "HV-07 Agder",
        "mgrs": "32V LK 6850 5850",
        "lat": 58.24797,
        "lon": 6.75963,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "NorNed-kabel",
        "suspect": false
    },
    {
        "id": "KO-HV-07-085",
        "name": "Varoddbruene (E18)",
        "district": "HV-07",
        "districtName": "HV-07 Agder",
        "mgrs": "32V MK 4350 1550",
        "lat": 57.87782,
        "lon": 8.04745,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "E18 over Topdalsfjorden",
        "suspect": false
    },
    {
        "id": "KO-HV-07-086",
        "name": "Fedafjorden Bru (E39)",
        "district": "HV-07",
        "districtName": "HV-07 Agder",
        "mgrs": "32V LK 6950 5650",
        "lat": 58.23032,
        "lon": 6.77777,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "E39 Sørland-Vestland",
        "suspect": false
    },
    {
        "id": "KO-HV-07-087",
        "name": "Kvineshei-tunnelen (Sørlandsbanen)",
        "district": "HV-07",
        "districtName": "HV-07 Agder",
        "mgrs": "32V LK 7650 6350",
        "lat": 58.29517,
        "lon": 6.89316,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "lengste tunnel banen",
        "suspect": false
    },
    {
        "id": "KO-HV-07-088",
        "name": "Holen/Brokke Kraftverk (Setesdal)",
        "district": "HV-07",
        "districtName": "HV-07 Agder",
        "mgrs": "32V ML 1850 4550",
        "lat": 59.04119,
        "lon": 7.57975,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "kraft + demning",
        "suspect": false
    },
    {
        "id": "KO-HV-07-089",
        "name": "Støleheia Trafostasjon (Vennesla)",
        "district": "HV-07",
        "districtName": "HV-07 Agder",
        "mgrs": "32V MK 3550 2550",
        "lat": 57.96654,
        "lon": 7.90987,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "420kV Agder-nav",
        "suspect": false
    },
    {
        "id": "KO-HV-07-090",
        "name": "Arendal Havn/Eydehavn",
        "district": "HV-07",
        "districtName": "HV-07 Agder",
        "mgrs": "32V MK 8850 4650",
        "lat": 58.15968,
        "lon": 8.80466,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "reserve-SPOD + Morrow batteri",
        "suspect": false
    },
    {
        "id": "KO-HV-07-091",
        "name": "Baneheiatunnelen (E18 Kr.sand)",
        "district": "HV-07",
        "districtName": "HV-07 Agder",
        "mgrs": "32V MK 3950 1450",
        "lat": 57.86831,
        "lon": 7.98027,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "E18 gjennom sentrum",
        "suspect": false
    },
    {
        "id": "KO-HV-08-092",
        "name": "Vatneleiren (SK HV-08)",
        "district": "HV-08",
        "districtName": "HV-08 Rogaland",
        "mgrs": "32V LL 1650 3400",
        "lat": 58.90644,
        "lon": 5.814,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "KO + Osprey",
        "suspect": false
    },
    {
        "id": "KO-HV-08-093",
        "name": "NATO JWC / Jåttå",
        "district": "HV-08",
        "districtName": "HV-08 Rogaland",
        "mgrs": "32V LL 1150 4100",
        "lat": 58.96704,
        "lon": 5.7214,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "NATO kommandosenter (fjell)",
        "suspect": false
    },
    {
        "id": "KO-HV-08-094",
        "name": "Sola Flystasjon (130 LV/APOD)",
        "district": "HV-08",
        "districtName": "HV-08 Rogaland",
        "mgrs": "32V LL 0950 3500",
        "lat": 58.91236,
        "lon": 5.69184,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "330 skv, AWACS FOB",
        "suspect": false
    },
    {
        "id": "KO-HV-08-095",
        "name": "Madlaleiren (KNM Harald Haarfagre)",
        "district": "HV-08",
        "districtName": "HV-08 Rogaland",
        "mgrs": "32V LL 0850 4350",
        "lat": 58.98812,
        "lon": 5.66715,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "rekruttskole Sjø/Luft",
        "suspect": false
    },
    {
        "id": "KO-HV-08-096",
        "name": "Ulsnes Orlogsstasjon (Hundvåg)",
        "district": "HV-08",
        "districtName": "HV-08 Rogaland",
        "mgrs": "32V LL 1250 4600",
        "lat": 59.01231,
        "lon": 5.73451,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "fremskutt marinebase",
        "suspect": false
    },
    {
        "id": "KO-HV-08-097",
        "name": "Risavika Havn/LNG (SPOD Sørvest)",
        "district": "HV-08",
        "districtName": "HV-08 Rogaland",
        "mgrs": "32V LL 0400 4200",
        "lat": 58.97264,
        "lon": 5.59032,
        "kat": "TR",
        "cats": [
            "TR",
            "EN"
        ],
        "why": "RoRo + LNG-terminal",
        "suspect": false
    },
    {
        "id": "KO-HV-08-098",
        "name": "Kystradarkjede Vest (Karmøy)",
        "district": "HV-08",
        "districtName": "HV-08 Rogaland",
        "mgrs": "32V LL 0050 7500",
        "lat": 59.26683,
        "lon": 5.49949,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "maritimt bilde Kårstø",
        "suspect": false
    },
    {
        "id": "KO-HV-08-099",
        "name": "Sola sjø/FLO drivstoffdepot",
        "district": "HV-08",
        "districtName": "HV-08 Rogaland",
        "mgrs": "32V LL 0900 3700",
        "lat": 58.93007,
        "lon": 5.68145,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "F-76/F-34 fjelldepot",
        "suspect": false
    },
    {
        "id": "KO-HV-08-100",
        "name": "Kårstø Gassprosessering (Tysvær)",
        "district": "HV-08",
        "districtName": "HV-08 Rogaland",
        "mgrs": "32V LL 8950 2310",
        "lat": 58.83362,
        "lon": 7.08581,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "gasseksport Europa HVT",
        "suspect": false
    },
    {
        "id": "KO-HV-08-101",
        "name": "Kvilldal Kraftverk/North Sea Link",
        "district": "HV-08",
        "districtName": "HV-08 Rogaland",
        "mgrs": "32V LM 4320 0980",
        "lat": 59.59695,
        "lon": 6.22211,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "største effekt, UK-kabel",
        "suspect": false
    },
    {
        "id": "KO-HV-08-102",
        "name": "Rennfast-tunnelene (E39)",
        "district": "HV-08",
        "districtName": "HV-08 Rogaland",
        "mgrs": "32V LL 1050 5150",
        "lat": 59.06074,
        "lon": 5.69501,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "undersjøisk E39 nordover",
        "suspect": false
    },
    {
        "id": "KO-HV-08-103",
        "name": "Ferge Mortavika-Arsvågen (E39)",
        "district": "HV-08",
        "districtName": "HV-08 Rogaland",
        "mgrs": "32V LL 0750 6350",
        "lat": 59.16698,
        "lon": 5.63225,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "Kyststamvei-samband",
        "suspect": false
    },
    {
        "id": "KO-HV-08-104",
        "name": "Ganddal Godsterminal (Sandnes)",
        "district": "HV-08",
        "districtName": "HV-08 Rogaland",
        "mgrs": "32V LL 1250 2650",
        "lat": 58.83747,
        "lon": 5.751,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "Sørlandsbanen gods",
        "suspect": false
    },
    {
        "id": "KO-HV-08-105",
        "name": "Karmsundbrua (E134)",
        "district": "HV-08",
        "districtName": "HV-08 Rogaland",
        "mgrs": "32V LL 8850 8250",
        "lat": 59.36649,
        "lon": 7.03828,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "eneste landfaste til Karmøy",
        "suspect": false
    },
    {
        "id": "KO-HV-08-106",
        "name": "Blåsjø/Ulla-Førre damanlegg",
        "district": "HV-08",
        "districtName": "HV-08 Rogaland",
        "mgrs": "32V LM 6850 3550",
        "lat": 59.83627,
        "lon": 6.65377,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "største energimagasin",
        "suspect": false
    },
    {
        "id": "KO-HV-08-107",
        "name": "Lysebotn Kraftverk II",
        "district": "HV-08",
        "districtName": "HV-08 Rogaland",
        "mgrs": "32V LL 4250 4950",
        "lat": 59.05581,
        "lon": 6.25374,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "420kV Nord-Jæren",
        "suspect": false
    },
    {
        "id": "KO-HV-09-108",
        "name": "Haakonsvern Orlogsbase",
        "district": "HV-09",
        "districtName": "HV-09 Bergenhus (Vestland)",
        "mgrs": "32V LN 9500 1300",
        "lat": 60.53933,
        "lon": 7.0862,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "Sjøforsvarets hovedbase, MJK, ubåt",
        "suspect": false
    },
    {
        "id": "KO-HV-09-109",
        "name": "Bergenhus Festning (SK HV-09)",
        "district": "HV-09",
        "districtName": "HV-09 Bergenhus (Vestland)",
        "mgrs": "32V LN 9800 2000",
        "lat": 60.60292,
        "lon": 7.13724,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "KO + Sjøforsvarets skoler",
        "suspect": false
    },
    {
        "id": "KO-HV-09-110",
        "name": "Flesland Flystasjon (APOD)",
        "district": "HV-09",
        "districtName": "HV-09 Bergenhus (Vestland)",
        "mgrs": "32V LN 9450 0950",
        "lat": 60.5078,
        "lon": 7.07895,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "330 skv, MPA",
        "suspect": false
    },
    {
        "id": "KO-HV-09-111",
        "name": "Ulven Leir/skytefelt (Os)",
        "district": "HV-09",
        "districtName": "HV-09 Bergenhus (Vestland)",
        "mgrs": "32V LM 9800 9600",
        "lat": 60.38755,
        "lon": 7.14955,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "HV-09 + Bjørn West",
        "suspect": false
    },
    {
        "id": "KO-HV-09-112",
        "name": "Sjøforsvarets forsyningsbase (Dolvik)",
        "district": "HV-09",
        "districtName": "HV-09 Bergenhus (Vestland)",
        "mgrs": "32V LN 9600 1200",
        "lat": 60.53062,
        "lon": 7.10494,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "ammo/NSM fjelldepot",
        "suspect": false
    },
    {
        "id": "KO-HV-09-113",
        "name": "Bergen Havn/Dokken (SPOD)",
        "district": "HV-09",
        "districtName": "HV-09 Bergenhus (Vestland)",
        "mgrs": "32V LN 9700 1900",
        "lat": 60.59369,
        "lon": 7.11951,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "RoRo Vestlandet",
        "suspect": false
    },
    {
        "id": "KO-HV-09-114",
        "name": "Kystradarkjede Vest (Korsfjorden)",
        "district": "HV-09",
        "districtName": "HV-09 Bergenhus (Vestland)",
        "mgrs": "32V LN 8500 1000",
        "lat": 60.50968,
        "lon": 6.9058,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "sensor innseiling",
        "suspect": false
    },
    {
        "id": "KO-HV-09-115",
        "name": "Bømoen Leir/flystripe (Voss)",
        "district": "HV-09",
        "districtName": "HV-09 Bergenhus (Vestland)",
        "mgrs": "32V LN 6600 4400",
        "lat": 60.80879,
        "lon": 6.53694,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "logistikk E16/Bergensbanen",
        "suspect": false
    },
    {
        "id": "KO-HV-09-116",
        "name": "Kollsnes Gassprosessering (Øygarden)",
        "district": "HV-09",
        "districtName": "HV-09 Bergenhus (Vestland)",
        "mgrs": "32V LN 7500 2300",
        "lat": 60.62333,
        "lon": 6.71563,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "~40% gasseksport",
        "suspect": false
    },
    {
        "id": "KO-HV-09-117",
        "name": "Mongstad Oljeraffineri",
        "district": "HV-09",
        "districtName": "HV-09 Bergenhus (Vestland)",
        "mgrs": "32V LN 8750 4350",
        "lat": 60.81097,
        "lon": 6.93211,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "F-76/F-34 raffineri",
        "suspect": false
    },
    {
        "id": "KO-HV-09-118",
        "name": "Sotrabrua (Rv555)",
        "district": "HV-09",
        "districtName": "HV-09 Bergenhus (Vestland)",
        "mgrs": "32V LN 8850 0550",
        "lat": 60.47029,
        "lon": 6.97202,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "eneste faste til Sotra/Kollsnes",
        "suspect": false
    },
    {
        "id": "KO-HV-09-119",
        "name": "Hardangerbrua (Rv7/13)",
        "district": "HV-09",
        "districtName": "HV-09 Bergenhus (Vestland)",
        "mgrs": "32V LM 7650 3210",
        "lat": 59.80822,
        "lon": 6.7984,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "lengste hengebru øst-vest",
        "suspect": false
    },
    {
        "id": "KO-HV-09-120",
        "name": "Finsetunnelen (Bergensbanen)",
        "district": "HV-09",
        "districtName": "HV-09 Bergenhus (Vestland)",
        "mgrs": "32V MN 1250 1850",
        "lat": 60.59288,
        "lon": 7.40259,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "høyfjells jernbane-flaskehals",
        "suspect": false
    },
    {
        "id": "KO-HV-09-121",
        "name": "Sima Kraftverk (Eidfjord)",
        "district": "HV-09",
        "districtName": "HV-09 Bergenhus (Vestland)",
        "mgrs": "32V LM 9850 3550",
        "lat": 59.84471,
        "lon": 7.1887,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "stort vannkraftverk",
        "suspect": false
    },
    {
        "id": "KO-HV-09-122",
        "name": "Lærdalstunnelen (E16)",
        "district": "HV-09",
        "districtName": "HV-09 Bergenhus (Vestland)",
        "mgrs": "32V MN 9870 5430",
        "lat": 60.92384,
        "lon": 8.97611,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "verdens lengste veitunnel",
        "suspect": false
    },
    {
        "id": "KO-HV-09-123",
        "name": "Stureterminalen (Øygarden)",
        "district": "HV-09",
        "districtName": "HV-09 Bergenhus (Vestland)",
        "mgrs": "32V LN 7850 3450",
        "lat": 60.72758,
        "lon": 6.77242,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "råolje-hub",
        "suspect": false
    },
    {
        "id": "KO-HV-09-124",
        "name": "Flesland POL/flydrivstoff",
        "district": "HV-09",
        "districtName": "HV-09 Bergenhus (Vestland)",
        "mgrs": "32V LN 9450 0950",
        "lat": 60.5078,
        "lon": 7.07895,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "jetfuel APOD",
        "suspect": false
    },
    {
        "id": "KO-HV-11-125",
        "name": "Setnesmoen Leir (SK HV-11)",
        "district": "HV-11",
        "districtName": "HV-11 Møre og Fjordane",
        "mgrs": "32V MQ 6600 3250",
        "lat": 62.52198,
        "lon": 8.33963,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "KO + Archery, alliert vintertrening",
        "suspect": false
    },
    {
        "id": "KO-HV-11-126",
        "name": "Åndalsnes Havn/Raumabanen (SPOD)",
        "district": "HV-11",
        "districtName": "HV-11 Møre og Fjordane",
        "mgrs": "32V MQ 6550 3450",
        "lat": 62.53988,
        "lon": 8.32951,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "havn+bane øst",
        "suspect": false
    },
    {
        "id": "KO-HV-11-127",
        "name": "Kvernberget lufthavn (Kr.sund)",
        "district": "HV-11",
        "districtName": "HV-11 Møre og Fjordane",
        "mgrs": "32V MQ 3500 8900",
        "lat": 63.02483,
        "lon": 7.71569,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "offshore helikopter-hub/FOB",
        "suspect": false
    },
    {
        "id": "KO-HV-11-128",
        "name": "Ålesund lufthavn Vigra (APOD)",
        "district": "HV-11",
        "districtName": "HV-11 Møre og Fjordane",
        "mgrs": "32V LQ 5500 3200",
        "lat": 62.49069,
        "lon": 6.18572,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "luftmottak Sunnmøre",
        "suspect": false
    },
    {
        "id": "KO-HV-11-129",
        "name": "Vestbase (Kr.sund)",
        "district": "HV-11",
        "districtName": "HV-11 Møre og Fjordane",
        "mgrs": "32V MQ 3600 8850",
        "lat": 63.02052,
        "lon": 7.73564,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "offshore logistikkbase",
        "suspect": false
    },
    {
        "id": "KO-HV-11-130",
        "name": "Kystradarkjede Nordvest (Stad-Smøla)",
        "district": "HV-11",
        "districtName": "HV-11 Møre og Fjordane",
        "mgrs": "32V LQ 1200 8500",
        "lat": 62.94613,
        "lon": 5.29385,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "farvannsovervåkning",
        "suspect": false
    },
    {
        "id": "KO-HV-11-131",
        "name": "Molde lufthavn Årø (APOD)",
        "district": "HV-11",
        "districtName": "HV-11 Møre og Fjordane",
        "mgrs": "32V MQ 2150 5450",
        "lat": 62.71262,
        "lon": 7.46528,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "luftmottak Romsdal",
        "suspect": false
    },
    {
        "id": "KO-HV-11-132",
        "name": "Ulsteinvik maritim cluster",
        "district": "HV-11",
        "districtName": "HV-11 Møre og Fjordane",
        "mgrs": "32V LQ 4300 0900",
        "lat": 62.27965,
        "lon": 5.97405,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "verft (reparasjon fartøy)",
        "suspect": false
    },
    {
        "id": "KO-HV-11-133",
        "name": "Nyhamna Gassprosess (Aukra)",
        "district": "HV-11",
        "districtName": "HV-11 Møre og Fjordane",
        "mgrs": "32V LQ 6540 2100",
        "lat": 62.39598,
        "lon": 6.39591,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "Ormen Lange → UK",
        "suspect": false
    },
    {
        "id": "KO-HV-11-134",
        "name": "Tjeldbergodden (Aure)",
        "district": "HV-11",
        "districtName": "HV-11 Møre og Fjordane",
        "mgrs": "32V MR 3450 1250",
        "lat": 63.2356,
        "lon": 7.69639,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "metanol/gass",
        "suspect": false
    },
    {
        "id": "KO-HV-11-135",
        "name": "Ørskog Trafostasjon",
        "district": "HV-11",
        "districtName": "HV-11 Møre og Fjordane",
        "mgrs": "32V LQ 8250 2150",
        "lat": 62.40625,
        "lon": 6.72608,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "420kV Midt-Norge×Vestland",
        "suspect": false
    },
    {
        "id": "KO-HV-11-136",
        "name": "Aura Kraftverk (Sunndal)",
        "district": "HV-11",
        "districtName": "HV-11 Møre og Fjordane",
        "mgrs": "32V MQ 6850 4550",
        "lat": 62.63888,
        "lon": 8.38578,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "kraft → Hydro aluminium",
        "suspect": false
    },
    {
        "id": "KO-HV-11-137",
        "name": "Gjemnessundbrua/Krifast (E39)",
        "district": "HV-11",
        "districtName": "HV-11 Møre og Fjordane",
        "mgrs": "32V MQ 2550 7850",
        "lat": 62.92879,
        "lon": 7.53277,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "hengebru Nordmøre",
        "suspect": false
    },
    {
        "id": "KO-HV-11-138",
        "name": "Tresfjordbrua (E136)",
        "district": "HV-11",
        "districtName": "HV-11 Møre og Fjordane",
        "mgrs": "32V LQ 9550 4150",
        "lat": 62.58953,
        "lon": 6.96529,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "tungtransport-akse",
        "suspect": false
    },
    {
        "id": "KO-HV-11-139",
        "name": "Eiksundtunnelen (Fv653)",
        "district": "HV-11",
        "districtName": "HV-11 Møre og Fjordane",
        "mgrs": "32V LQ 4550 1250",
        "lat": 62.31206,
        "lon": 6.01905,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "dyp undersjøisk til verft-øyer",
        "suspect": false
    },
    {
        "id": "KO-HV-12-140",
        "name": "Værnes Garnison/Flystasjon (SK HV-12/APOD)",
        "district": "HV-12",
        "districtName": "HV-12 Trøndelag",
        "mgrs": "32V PR 3450 7890",
        "lat": 63.81165,
        "lon": 11.73219,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "KO + USMC FOL",
        "suspect": false
    },
    {
        "id": "KO-HV-12-141",
        "name": "Ørland Flystasjon (132 LV)",
        "district": "HV-12",
        "districtName": "HV-12 Trøndelag",
        "mgrs": "32V NR 9850 5450",
        "lat": 63.60478,
        "lon": 10.98615,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "F-35 hovedbase HVT#1",
        "suspect": false
    },
    {
        "id": "KO-HV-12-142",
        "name": "MCPP-N Frigård (fjellhaller)",
        "district": "HV-12",
        "districtName": "HV-12 Trøndelag",
        "mgrs": "32V PR 4100 7900",
        "lat": 63.80999,
        "lon": 11.86412,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "USMC forhåndslager",
        "suspect": false
    },
    {
        "id": "KO-HV-12-143",
        "name": "MCPP-N Tromsdal/Hammer (ammo)",
        "district": "HV-12",
        "districtName": "HV-12 Trøndelag",
        "mgrs": "32V PR 4800 9500",
        "lat": 63.9505,
        "lon": 12.02145,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "alliert ammo/POL fjell",
        "suspect": false
    },
    {
        "id": "KO-HV-12-144",
        "name": "Trondheim Havn/Nyhavna (SPOD)",
        "district": "HV-12",
        "districtName": "HV-12 Trøndelag",
        "mgrs": "32V NR 6000 3500",
        "lat": 63.43845,
        "lon": 10.20277,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "RoRo → MCPP-N",
        "suspect": false
    },
    {
        "id": "KO-HV-12-145",
        "name": "Kopparen Radarstasjon (Fosen)",
        "district": "HV-12",
        "districtName": "HV-12 Trøndelag",
        "mgrs": "32V NR 8500 7800",
        "lat": 63.81909,
        "lon": 10.72692,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "beskytter Ørland",
        "suspect": false
    },
    {
        "id": "KO-HV-12-146",
        "name": "Gråkallen Radarstasjon",
        "district": "HV-12",
        "districtName": "HV-12 Trøndelag",
        "mgrs": "32V NR 5500 3000",
        "lat": 63.39439,
        "lon": 10.10085,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "NATINAMDS luftbilde",
        "suspect": false
    },
    {
        "id": "KO-HV-12-147",
        "name": "Tarva Skyte-/øvingsfelt",
        "district": "HV-12",
        "districtName": "HV-12 Trøndelag",
        "mgrs": "32V NR 8800 6600",
        "lat": 63.71071,
        "lon": 10.78103,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "F-35 luft-bakke",
        "suspect": false
    },
    {
        "id": "KO-HV-12-148",
        "name": "Agdenes Sensorområde",
        "district": "HV-12",
        "districtName": "HV-12 Trøndelag",
        "mgrs": "32V NR 6500 4500",
        "lat": 63.5273,
        "lon": 10.30705,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "chokepoint Trondheimsfjord",
        "suspect": false
    },
    {
        "id": "KO-HV-12-149",
        "name": "Haltdalen Øvingssenter",
        "district": "HV-12",
        "districtName": "HV-12 Trøndelag",
        "mgrs": "32V PQ 2500 7000",
        "lat": 62.83874,
        "lon": 11.4548,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "Rype, Røros-aksen",
        "suspect": false
    },
    {
        "id": "KO-HV-12-150",
        "name": "Bjugn MCPP-N",
        "district": "HV-12",
        "districtName": "HV-12 Trøndelag",
        "mgrs": "32V NR 9200 6100",
        "lat": 63.66484,
        "lon": 10.85899,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "USMC flystøtte/logistikk",
        "suspect": false
    },
    {
        "id": "KO-HV-12-151",
        "name": "Muruvik Oljeterminal",
        "district": "HV-12",
        "districtName": "HV-12 Trøndelag",
        "mgrs": "32V PR 4100 8200",
        "lat": 63.83688,
        "lon": 11.86686,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "jetfuel → Værnes",
        "suspect": false
    },
    {
        "id": "KO-HV-12-152",
        "name": "Værnes POL",
        "district": "HV-12",
        "districtName": "HV-12 Trøndelag",
        "mgrs": "32V PR 1550 4250",
        "lat": 63.49203,
        "lon": 11.31984,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "jetfuel APOD",
        "suspect": false
    },
    {
        "id": "KO-HV-12-153",
        "name": "Hell Broer (E6/Nordlandsbanen)",
        "district": "HV-12",
        "districtName": "HV-12 Trøndelag",
        "mgrs": "32V PR 1450 4350",
        "lat": 63.50132,
        "lon": 11.3005,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "nord-sør chokepoint",
        "suspect": false
    },
    {
        "id": "KO-HV-12-154",
        "name": "Trondheim Havn Brattøra",
        "district": "HV-12",
        "districtName": "HV-12 Trøndelag",
        "mgrs": "32V NR 6950 3550",
        "lat": 63.44121,
        "lon": 10.39334,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "SPOD + bane",
        "suspect": false
    },
    {
        "id": "KO-HV-12-155",
        "name": "Agdenes gapet (fjordinnløp)",
        "district": "HV-12",
        "districtName": "HV-12 Trøndelag",
        "mgrs": "32V NR 4250 5650",
        "lat": 63.6339,
        "lon": 9.85782,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "innseiling Trondheim",
        "suspect": false
    },
    {
        "id": "KO-HV-12-156",
        "name": "Trondheim Sentralstasjon/skiftegård",
        "district": "HV-12",
        "districtName": "HV-12 Trøndelag",
        "mgrs": "32V NR 6980 3420",
        "lat": 63.42949,
        "lon": 10.39879,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "Dovre×Nordland×Meråker",
        "suspect": false
    },
    {
        "id": "KO-HV-12-157",
        "name": "Tilkomstveier MCPP-N (Tromsdal)",
        "district": "HV-12",
        "districtName": "HV-12 Trøndelag",
        "mgrs": "32V PR 2150 7850",
        "lat": 63.81282,
        "lon": 11.46812,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "utløp fjellhaller",
        "suspect": false
    },
    {
        "id": "KO-HV-12-158",
        "name": "Ørland POL/bakkestruktur",
        "district": "HV-12",
        "districtName": "HV-12 Trøndelag",
        "mgrs": "32V NR 3550 6750",
        "lat": 63.73339,
        "lon": 9.71906,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "jetfuel F-35",
        "suspect": false
    },
    {
        "id": "KO-HV-12-159",
        "name": "Meråkerbanen/Storlien",
        "district": "HV-12",
        "districtName": "HV-12 Trøndelag",
        "mgrs": "32V PR 4550 3250",
        "lat": 63.39139,
        "lon": 11.91241,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "bane mot Sverige",
        "suspect": false
    },
    {
        "id": "KO-HV-12-160",
        "name": "Nea Kraftverk/420kV (Tydal)",
        "district": "HV-12",
        "districtName": "HV-12 Trøndelag",
        "mgrs": "32V PR 5550 1150",
        "lat": 63.19897,
        "lon": 12.09198,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "kraft-node mot Sverige",
        "suspect": false
    },
    {
        "id": "KO-HV-12-161",
        "name": "Kroppanbrua (E6 sør)",
        "district": "HV-12",
        "districtName": "HV-12 Trøndelag",
        "mgrs": "32V NR 6850 3150",
        "lat": 63.40551,
        "lon": 10.37159,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "E6 over Nidelva",
        "suspect": false
    },
    {
        "id": "KO-HV-14-162",
        "name": "FOH Reitan",
        "district": "HV-14",
        "districtName": "HV-14 Sør-Hålogaland (Nordland sør)",
        "mgrs": "33W VP 7890 4567",
        "lat": 66.23044,
        "lon": 14.53098,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "Forsvarets operative HK — HVT#1",
        "suspect": false
    },
    {
        "id": "KO-HV-14-163",
        "name": "Drevjamoen Leir (SK HV-14)",
        "district": "HV-14",
        "districtName": "HV-14 Sør-Hålogaland (Nordland sør)",
        "mgrs": "33W VN 2450 1600",
        "lat": 65.05915,
        "lon": 13.39538,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "KO + Heron",
        "suspect": false
    },
    {
        "id": "KO-HV-14-164",
        "name": "Stasjon Fauske (E-tj SIGINT)",
        "district": "HV-14",
        "districtName": "HV-14 Sør-Hålogaland (Nordland sør)",
        "mgrs": "33W WQ 1250 8500",
        "lat": 67.48076,
        "lon": 15.29258,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "signaletterretning",
        "suspect": false
    },
    {
        "id": "KO-HV-14-165",
        "name": "Bodø Hovedflyplass (APOD)",
        "district": "HV-14",
        "districtName": "HV-14 Sør-Hålogaland (Nordland sør)",
        "mgrs": "33W VP 6712 3456",
        "lat": 66.12976,
        "lon": 14.27195,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "330 skv, oppmarsj",
        "suspect": false
    },
    {
        "id": "KO-HV-14-166",
        "name": "Cyberforsvarets node Bodø/Salten",
        "district": "HV-14",
        "districtName": "HV-14 Sør-Hålogaland (Nordland sør)",
        "mgrs": "33W VP 7100 4800",
        "lat": 66.25071,
        "lon": 14.35481,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "sikker komm FOH",
        "suspect": false
    },
    {
        "id": "KO-HV-14-167",
        "name": "Fauske Jernbaneterminal",
        "district": "HV-14",
        "districtName": "HV-14 Sør-Hålogaland (Nordland sør)",
        "mgrs": "33W WQ 1150 8200",
        "lat": 67.45389,
        "lon": 15.26888,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "bane→E6 omlasting",
        "suspect": false
    },
    {
        "id": "KO-HV-14-168",
        "name": "Kystradarkjede Vestfjorden",
        "district": "HV-14",
        "districtName": "HV-14 Sør-Hålogaland (Nordland sør)",
        "mgrs": "33W VP 1500 5500",
        "lat": 66.3033,
        "lon": 13.10454,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "sensor innseiling",
        "suspect": false
    },
    {
        "id": "KO-HV-14-169",
        "name": "FLO fjellanlegg Drevjadalen",
        "district": "HV-14",
        "districtName": "HV-14 Sør-Hålogaland (Nordland sør)",
        "mgrs": "33W VN 2600 1800",
        "lat": 65.07742,
        "lon": 13.42618,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "depot langs banen",
        "suspect": false
    },
    {
        "id": "KO-HV-14-170",
        "name": "LFS Sørreisa avd. Bodø",
        "district": "HV-14",
        "districtName": "HV-14 Sør-Hålogaland (Nordland sør)",
        "mgrs": "33W VP 6900 3800",
        "lat": 66.16081,
        "lon": 14.31275,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "sensor/radiolinje",
        "suspect": false
    },
    {
        "id": "KO-HV-14-171",
        "name": "Bognes-Skarberget ferge (E6)",
        "district": "HV-14",
        "districtName": "HV-14 Sør-Hålogaland (Nordland sør)",
        "mgrs": "33W WR 5450 1550",
        "lat": 67.74951,
        "lon": 16.28994,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "nasjonalt nåløye",
        "suspect": false
    },
    {
        "id": "KO-HV-14-172",
        "name": "Fauske Godsterminal",
        "district": "HV-14",
        "districtName": "HV-14 Sør-Hålogaland (Nordland sør)",
        "mgrs": "33W WQ 1850 7250",
        "lat": 67.36832,
        "lon": 15.43093,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "siste bane-omlasting nord",
        "suspect": false
    },
    {
        "id": "KO-HV-14-173",
        "name": "Sørfold-tunnelene (E6)",
        "district": "HV-14",
        "districtName": "HV-14 Sør-Hålogaland (Nordland sør)",
        "mgrs": "33W WR 1550 0550",
        "lat": 67.66449,
        "lon": 15.3656,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "16 tunneler, ingen omkjøring",
        "suspect": false
    },
    {
        "id": "KO-HV-14-174",
        "name": "Bodø Lufthavn/POL",
        "district": "HV-14",
        "districtName": "HV-14 Sør-Hålogaland (Nordland sør)",
        "mgrs": "33W WQ 0250 6350",
        "lat": 67.28816,
        "lon": 15.05814,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "jetfuel APOD",
        "suspect": false
    },
    {
        "id": "KO-HV-14-175",
        "name": "Bodø Havn/RoRo",
        "district": "HV-14",
        "districtName": "HV-14 Sør-Hålogaland (Nordland sør)",
        "mgrs": "33W WQ 0450 6550",
        "lat": 67.30608,
        "lon": 15.10464,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "SPOD Nordland",
        "suspect": false
    },
    {
        "id": "KO-HV-14-176",
        "name": "Saltfjellovergangen (E6/bane)",
        "district": "HV-14",
        "districtName": "HV-14 Sør-Hålogaland (Nordland sør)",
        "mgrs": "33W VP 9550 0850",
        "lat": 65.89765,
        "lon": 14.90136,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "arktisk chokepoint",
        "suspect": false
    },
    {
        "id": "KO-HV-14-177",
        "name": "Svartisen Kraftverk (Meløy)",
        "district": "HV-14",
        "districtName": "HV-14 Sør-Hålogaland (Nordland sør)",
        "mgrs": "33W VQ 3450 1250",
        "lat": 66.82365,
        "lon": 13.50858,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "stort vannkraftverk",
        "suspect": false
    },
    {
        "id": "KO-HV-14-178",
        "name": "Mo i Rana Godsterminal/havn",
        "district": "HV-14",
        "districtName": "HV-14 Sør-Hålogaland (Nordland sør)",
        "mgrs": "33W VP 6250 8150",
        "lat": 66.55031,
        "lon": 14.15562,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "dypvann + bane + stål",
        "suspect": false
    },
    {
        "id": "KO-HV-14-179",
        "name": "Helgelandsbrua (Fv17)",
        "district": "HV-14",
        "districtName": "HV-14 Sør-Hålogaland (Nordland sør)",
        "mgrs": "33W UP 8450 4850",
        "lat": 66.23527,
        "lon": 12.43104,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "skråkabelbru reserveakse",
        "suspect": false
    },
    {
        "id": "KO-HV-14-180",
        "name": "Nedre Røssåga Kraftverk (Hemnes)",
        "district": "HV-14",
        "districtName": "HV-14 Sør-Hålogaland (Nordland sør)",
        "mgrs": "33W VP 4550 2150",
        "lat": 66.00963,
        "lon": 13.7988,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "kraft-node Trøndelag-Nordland",
        "suspect": false
    },
    {
        "id": "KO-HV-16-181",
        "name": "Bjerkvik Leir (SK HV-16/BTV)",
        "district": "HV-16",
        "districtName": "HV-16 Nord-Hålogaland (Troms + Ofoten)",
        "mgrs": "33W WS 0950 0850",
        "lat": 68.58857,
        "lon": 15.23331,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "KO + Claymore, stridsvogn-verksted",
        "suspect": false
    },
    {
        "id": "KO-HV-16-182",
        "name": "Evenes Flystasjon (133 LV QRA/MPA)",
        "district": "HV-16",
        "districtName": "HV-16 Nord-Hålogaland (Troms + Ofoten)",
        "mgrs": "33W WS 0250 0150",
        "lat": 68.52594,
        "lon": 15.06132,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "F-35 QRA + P-8",
        "suspect": false
    },
    {
        "id": "KO-HV-16-183",
        "name": "Narvik Havn/Ofotbanen (SPOD)",
        "district": "HV-16",
        "districtName": "HV-16 Nord-Hålogaland (Troms + Ofoten)",
        "mgrs": "33W VS 9200 9500",
        "lat": 69.36437,
        "lon": 14.79673,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "isfri dypvann + bane Sverige",
        "suspect": false
    },
    {
        "id": "KO-HV-16-184",
        "name": "Ramsund Orlogsbase (MJK/POL)",
        "district": "HV-16",
        "districtName": "HV-16 Nord-Hålogaland (Troms + Ofoten)",
        "mgrs": "33W WS 0100 0500",
        "lat": 68.55734,
        "lon": 15.02463,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "SOF-base + ammo fjell",
        "suspect": false
    },
    {
        "id": "KO-HV-16-185",
        "name": "Setermoen Leir (Brig N)",
        "district": "HV-16",
        "districtName": "HV-16 Nord-Hålogaland (Troms + Ofoten)",
        "mgrs": "34W CB 9317 4122",
        "lat": 68.86147,
        "lon": 18.34498,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "Panser/Artilleri/E-bataljon",
        "suspect": false
    },
    {
        "id": "KO-HV-16-186",
        "name": "CRC Sørreisa",
        "district": "HV-16",
        "districtName": "HV-16 Nord-Hålogaland (Troms + Ofoten)",
        "mgrs": "34W CB 8723 7213",
        "lat": 69.13598,
        "lon": 18.16207,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "luftromskontroll nord (fjell)",
        "suspect": false
    },
    {
        "id": "KO-HV-16-187",
        "name": "Bardufoss Flystasjon/Heggelia",
        "district": "HV-16",
        "districtName": "HV-16 Nord-Hålogaland (Troms + Ofoten)",
        "mgrs": "34W DB 0069 6262",
        "lat": 69.05603,
        "lon": 18.5101,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "Brigadekommando + helikopter",
        "suspect": false
    },
    {
        "id": "KO-HV-16-188",
        "name": "Skjold Leir (Målselv)",
        "district": "HV-16",
        "districtName": "HV-16 Nord-Hålogaland (Troms + Ofoten)",
        "mgrs": "34W DB 4563 5607",
        "lat": 69.00996,
        "lon": 19.63997,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "2.bn + ingeniør, sperreakse",
        "suspect": false
    },
    {
        "id": "KO-HV-16-189",
        "name": "Trondenes Leir (Harstad/KJK)",
        "district": "HV-16",
        "districtName": "HV-16 Nord-Hålogaland (Troms + Ofoten)",
        "mgrs": "33W WS 1400 3800",
        "lat": 68.85295,
        "lon": 15.34785,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "Kystjeger + E-tj",
        "suspect": false
    },
    {
        "id": "KO-HV-16-190",
        "name": "Andøya Flystasjon (droner)",
        "district": "HV-16",
        "districtName": "HV-16 Nord-Hålogaland (Troms + Ofoten)",
        "mgrs": "33W WS 4500 8500",
        "lat": 69.27105,
        "lon": 16.13939,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "MPA/UAV GIUK",
        "suspect": false
    },
    {
        "id": "KO-HV-16-191",
        "name": "Blåtind/Setermoen skytefelt",
        "district": "HV-16",
        "districtName": "HV-16 Nord-Hålogaland (Troms + Ofoten)",
        "mgrs": "34W DB 0440 4506",
        "lat": 68.90001,
        "lon": 18.62008,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "samvirke-øvingsfelt",
        "suspect": false
    },
    {
        "id": "KO-HV-16-192",
        "name": "Sørkjosen/Nordreisa (sperreakse)",
        "district": "HV-16",
        "districtName": "HV-16 Nord-Hålogaland (Troms + Ofoten)",
        "mgrs": "34W DC 4500 4500",
        "lat": 69.8071,
        "lon": 19.57233,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "Lyngen-linja chokepoint",
        "suspect": false
    },
    {
        "id": "KO-HV-16-193",
        "name": "Ofotbanen/Rombaksbrua",
        "district": "HV-16",
        "districtName": "HV-16 Nord-Hålogaland (Troms + Ofoten)",
        "mgrs": "33W VS 9200 9500",
        "lat": 69.36437,
        "lon": 14.79673,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "eneste bane nord + Sverige",
        "suspect": false
    },
    {
        "id": "KO-HV-16-194",
        "name": "Narvik Havn/Fagernes",
        "district": "HV-16",
        "districtName": "HV-16 Nord-Hålogaland (Troms + Ofoten)",
        "mgrs": "33W VS 9100 9300",
        "lat": 69.3464,
        "lon": 14.77149,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "SPOD nord + malm",
        "suspect": false
    },
    {
        "id": "KO-HV-16-195",
        "name": "Evenes POL",
        "district": "HV-16",
        "districtName": "HV-16 Nord-Hålogaland (Troms + Ofoten)",
        "mgrs": "33W WS 0250 0150",
        "lat": 68.52594,
        "lon": 15.06132,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "jetfuel QRA",
        "suspect": false
    },
    {
        "id": "KO-HV-16-196",
        "name": "Ofoten Trafostasjon (Bjerkvik)",
        "district": "HV-16",
        "districtName": "HV-16 Nord-Hålogaland (Troms + Ofoten)",
        "mgrs": "33W WS 1250 0550",
        "lat": 68.56155,
        "lon": 15.30657,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "420kV nav Nord-Norge",
        "suspect": false
    },
    {
        "id": "KO-HV-16-197",
        "name": "Tjeldsundbrua (E10)",
        "district": "HV-16",
        "districtName": "HV-16 Nord-Hålogaland (Troms + Ofoten)",
        "mgrs": "33W WS 1230 5670",
        "lat": 69.02073,
        "lon": 15.30796,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "eneste vei til Hinnøya/Lofoten",
        "suspect": false
    },
    {
        "id": "KO-HV-16-198",
        "name": "Hålogalandsbrua (E6 Narvik)",
        "district": "HV-16",
        "districtName": "HV-16 Nord-Hålogaland (Troms + Ofoten)",
        "mgrs": "33W VS 9350 9650",
        "lat": 69.37786,
        "lon": 14.83476,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "hengebru E6",
        "suspect": false
    },
    {
        "id": "KO-HV-16-199",
        "name": "E6 Kvænangsfjellet",
        "district": "HV-16",
        "districtName": "HV-16 Nord-Hålogaland (Troms + Ofoten)",
        "mgrs": "34W DC 4500 4500",
        "lat": 69.8071,
        "lon": 19.57233,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "eneste vei HV-16↔HV-17",
        "suspect": false
    },
    {
        "id": "KO-HV-16-200",
        "name": "Innset/Altevatn Kraftverk (Bardu)",
        "district": "HV-16",
        "districtName": "HV-16 Nord-Hålogaland (Troms + Ofoten)",
        "mgrs": "34W DB 2281 1652",
        "lat": 68.64997,
        "lon": 19.10001,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "kraft Hæren + demning",
        "suspect": false
    },
    {
        "id": "KO-HV-16-201",
        "name": "Tromsø Havn/Grøtsund",
        "district": "HV-16",
        "districtName": "HV-16 Nord-Hålogaland (Troms + Ofoten)",
        "mgrs": "34W DD 2500 3500",
        "lat": 70.60869,
        "lon": 18.97583,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "alliert ubåtanløp",
        "suspect": false
    },
    {
        "id": "KO-HV-16-202",
        "name": "Tromsøysundtunnelen/Sandnessundbrua",
        "district": "HV-16",
        "districtName": "HV-16 Nord-Hålogaland (Troms + Ofoten)",
        "mgrs": "34W DC 1800 2800",
        "lat": 69.64771,
        "lon": 18.88717,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "eneste arterier Tromsøya",
        "suspect": false
    },
    {
        "id": "KO-HV-17-203",
        "name": "Porsangmoen Leir/GP (SK HV-17/FLF)",
        "district": "HV-17",
        "districtName": "HV-17 Finnmark",
        "mgrs": "35W MT 1250 8550",
        "lat": 70.16116,
        "lon": 24.6895,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "KO + Porsanger bn/Jeger",
        "suspect": false
    },
    {
        "id": "KO-HV-17-204",
        "name": "Globus Radaranlegg (Vardø)",
        "district": "HV-17",
        "districtName": "HV-17 Finnmark",
        "mgrs": "36W UC 5450 1100",
        "lat": 69.4683,
        "lon": 29.28093,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "strategisk E-tj sensor HVT",
        "suspect": false
    },
    {
        "id": "KO-HV-17-205",
        "name": "GSV Høybuktmoen (Sør-Varanger)",
        "district": "HV-17",
        "districtName": "HV-17 Finnmark",
        "mgrs": "36W VC 1150 3350",
        "lat": 69.6949,
        "lon": 30.71454,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "grensevakt Russland",
        "suspect": false
    },
    {
        "id": "KO-HV-17-206",
        "name": "Station Group Banak (Lakselv)",
        "district": "HV-17",
        "districtName": "HV-17 Finnmark",
        "mgrs": "35W MT 1200 8750",
        "lat": 70.17891,
        "lon": 24.6743,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "FOB, F-35/C-130",
        "suspect": false
    },
    {
        "id": "KO-HV-17-207",
        "name": "E-tj Stasjon Vadsø (Thomaselv)",
        "district": "HV-17",
        "districtName": "HV-17 Finnmark",
        "mgrs": "36W UC 1800 5000",
        "lat": 69.7945,
        "lon": 28.27452,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "SIGINT Nordflåten",
        "suspect": false
    },
    {
        "id": "KO-HV-17-208",
        "name": "Sperreakse Alta (Kvenvikmoen)",
        "district": "HV-17",
        "districtName": "HV-17 Finnmark",
        "mgrs": "34W EC 8500 4500",
        "lat": 69.79909,
        "lon": 23.20613,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "chokepoint E6 vestover",
        "suspect": false
    },
    {
        "id": "KO-HV-17-209",
        "name": "Halkavarre Skyte-/øvingsfelt",
        "district": "HV-17",
        "districtName": "HV-17 Finnmark",
        "mgrs": "35W MT 1800 7000",
        "lat": 70.02408,
        "lon": 24.84905,
        "kat": "MIL",
        "cats": [
            "MIL"
        ],
        "why": "største skytefelt",
        "suspect": false
    },
    {
        "id": "KO-HV-17-210",
        "name": "Kirkenes Havn (SPOD Øst)",
        "district": "HV-17",
        "districtName": "HV-17 Finnmark",
        "mgrs": "36W UC 8575 3797",
        "lat": 69.72504,
        "lon": 30.04493,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "østligste dypvann",
        "suspect": false
    },
    {
        "id": "KO-HV-17-211",
        "name": "Banak POL",
        "district": "HV-17",
        "districtName": "HV-17 Finnmark",
        "mgrs": "35W MT 1200 8750",
        "lat": 70.17891,
        "lon": 24.6743,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "jetfuel nordligste APOD",
        "suspect": false
    },
    {
        "id": "KO-HV-17-212",
        "name": "Alta Trafostasjon/E6",
        "district": "HV-17",
        "districtName": "HV-17 Finnmark",
        "mgrs": "34W EC 8500 4500",
        "lat": 69.79909,
        "lon": 23.20613,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "kraft-nav Vest-Finnmark",
        "suspect": false
    },
    {
        "id": "KO-HV-17-213",
        "name": "E6 Sennalandet (Alta-Hammerfest)",
        "district": "HV-17",
        "districtName": "HV-17 Finnmark",
        "mgrs": "35W MT 6550 4550",
        "lat": 69.81508,
        "lon": 26.10421,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "eneste vei Melkøya",
        "suspect": false
    },
    {
        "id": "KO-HV-17-214",
        "name": "Melkøya LNG (Hammerfest)",
        "district": "HV-17",
        "districtName": "HV-17 Finnmark",
        "mgrs": "35W LT 1250 8550",
        "lat": 70.1078,
        "lon": 22.05783,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "Snøhvit LNG-eksport HVT",
        "suspect": false
    },
    {
        "id": "KO-HV-17-215",
        "name": "Skaidi Trafostasjon",
        "district": "HV-17",
        "districtName": "HV-17 Finnmark",
        "mgrs": "35W MT 4550 5550",
        "lat": 69.90133,
        "lon": 25.57896,
        "kat": "EN",
        "cats": [
            "EN"
        ],
        "why": "kraft-nav Nord-Finnmark",
        "suspect": false
    },
    {
        "id": "KO-HV-17-216",
        "name": "Varangerbotn Bru (E6/E75)",
        "district": "HV-17",
        "districtName": "HV-17 Finnmark",
        "mgrs": "36W UC 1250 3550",
        "lat": 69.66107,
        "lon": 28.16211,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "øst-Finnmark knutepunkt",
        "suspect": false
    },
    {
        "id": "KO-HV-17-217",
        "name": "Repparfjordbrua (Rv94)",
        "district": "HV-17",
        "districtName": "HV-17 Finnmark",
        "mgrs": "35W LT 4550 5550",
        "lat": 69.86134,
        "lon": 22.97676,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "forsyning Hammerfest",
        "suspect": false
    },
    {
        "id": "KO-HV-17-218",
        "name": "Tana Bru (E6)",
        "district": "HV-17",
        "districtName": "HV-17 Finnmark",
        "mgrs": "36W VC 1550 8550",
        "lat": 70.16216,
        "lon": 30.76865,
        "kat": "TR",
        "cats": [
            "TR"
        ],
        "why": "eneste bru over Tanaelva",
        "suspect": false
    }
];
/** Objekter i ett HV-distrikt. */
export function kritiskeIDistrikt(district) {
    return KRITISKE_OBJEKTER.filter((o) => o.district === district);
}
/** Objekter som har en gitt kategori (MIL/EN/TR) — matcher på cats. */
export function kritiskeIKategori(kat) {
    return KRITISKE_OBJEKTER.filter((o) => o.cats.includes(kat));
}
/** Objekter med gyldig koordinat (ikke suspect) — trygge å tegne. */
export const KRITISKE_GYLDIGE = KRITISKE_OBJEKTER.filter((o) => !o.suspect);
/** Objekter med koordinat utenfor Norge-boksen (feil i MGRS-kilde — må rettes). */
export const KRITISKE_SUSPEKT = KRITISKE_OBJEKTER.filter((o) => o.suspect);
/** Distriktene som har minst ett kritisk objekt. */
export const KRITISKE_DISTRIKTER = ["HV-01", "HV-02", "HV-03", "HV-05", "HV-07", "HV-08", "HV-09", "HV-11", "HV-12", "HV-14", "HV-16", "HV-17"];
//# sourceMappingURL=kritiske-objekter.gen.js.map